<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Financial Accounts" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-financial-accounts-form [financialAccount]="financialAccounts"
                                      *ngIf="financialAccounts"></app-financial-accounts-form>
        </form>
      </div>
    </section>
  </div>
</div>
